/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const StaticGroupApi = {
  public: {},
  private: {
    fetchGroupPatientsWithPracticeId: (groupId, practiceId) => ProtectedHttpClient.get(`/staticgroup/${practiceId}/${groupId}/patients`),
    fetchGroupPatients: groupId => ProtectedHttpClient.get(`/staticgroup/${groupId}/patients`),
  }
};
export default StaticGroupApi;
